import Vue from "vue";

const getDefaultState = () => {
  return {
    theme: "silver",

    styles: {
      background: "white",
      backgroundCustom: "",
      bookedSessionBox: {
        background: "#fafafb",
        borderWidth: "1px",
        borderColor: "#efefef",
        borderHoverColor: "#ddd",
        borderRadius: "2px",
        nameColor: "#323333",
        nameFontWeight: "700",
        timeColor: "#323333",
        timeBackground: "#ffffff",
        timeBorderWidth: "1px",
        timeBorderColor: "#eaeaea",
        timeBorderRadius: "360px",
        cancelColor: "#444",
        cancelColorHover: "#444",
        cancelBackgroundHover: "#dcdfe0",
      },
    },
  };
};

const state = getDefaultState();

/*
  1. Set box style in style.js — remove the 'vue file' boxStyles
  2. Upon closing, save to database with all the new styles
  3. Create UI for editing the other parts (border, name, etc)
  3. Apply in preview
  4. Apply in calendar
  5. Create for other session types

  I need to take a moment to breathe, to zoom out, to actually think.
  Right now, I'm just trying to brute-force implement.
  But I'm not really thinking. That's why I'm stuck.
  So what am I trying to do right now exactly?
  What's in the way?
  What's the confusing or challenging part?
  What are you not understanding right now?
  What is unclear?

*/

// Synchronous
const mutations = {
  RESET_STATE(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  SET_THEME(state, newTheme) {
    state.theme = newTheme;
  },

  SET_STYLES(state, styles) {
    state.styles = styles;
  },

  SET_ONE_STYLE(state, styleData) {
    const { field, newStyle } = styleData;

    Vue.set(state.styles, field, newStyle);
  },

  SET_ONE_NESTED_STYLE(state, styleData) {
    const { nestingSpecifier, field, newStyle } = styleData;
    Vue.set(state.styles[nestingSpecifier], field, newStyle);
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setTheme({ commit }, newTheme) {
    commit("SET_THEME", newTheme);
  },

  setStyles({ commit }, styles) {
    commit("SET_STYLES", styles);
  },

  setOneStyle({ commit }, styleData) {
    commit("SET_ONE_STYLE", styleData);
  },

  setOneNestedStyle({ commit }, styleData) {
    commit("SET_ONE_NESTED_STYLE", styleData);
  },
};

const style = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default style;
